var map = {
	"./CA_thumb.png": "e5c9",
	"./HKLII_logo.png": "cf36",
	"./HKLII_logo.svg": "064a",
	"./HKLII_logotype.png": "632f",
	"./HKLII_logotype.svg": "892f",
	"./Predictor_thumb.png": "8857",
	"./case_summary_thumb.png": "ddd0",
	"./falm.png": "10e4",
	"./help.svg": "6a22",
	"./hkliilogo_dark.svg": "287c",
	"./nf_caseinfo.png": "eaaa",
	"./nf_entity.mp4": "532f",
	"./nf_entity.webm": "5442",
	"./nf_keywords.mp4": "2993",
	"./nf_keywords.webm": "fdc9",
	"./nf_legis.mp4": "4f4b",
	"./nf_legis.webm": "e3f2",
	"./nf_summary.mp4": "da1b",
	"./nf_summary.webm": "e298",
	"./nf_tagging.mp4": "8721",
	"./nf_tagging.webm": "16c2",
	"./patterns.png": "8fc1",
	"./sponsors23/footer_wave.svg": "c037",
	"./sponsors23/header_wave.svg": "8cce",
	"./sponsors23/ornaments_bottom.png": "2117",
	"./sponsors23/ornaments_top.png": "b486",
	"./sponsors23/p_sponsor_bg.png": "74ea",
	"./sponsors23/sample_logo.png": "1a4c",
	"./sponsors23/sponsor_RPC.png": "c01e",
	"./sponsors23/sponsor_footer.png": "830c",
	"./sponsors23/sponsor_header.png": "a5f9",
	"./t_advdemo.gif": "94ed",
	"./t_advdemo.mp4": "0748",
	"./t_advdemo.webm": "b790",
	"./t_highfive.png": "9ec8",
	"./t_layout.gif": "60a8",
	"./t_layout.mp4": "2c2a",
	"./t_layout.webm": "6545",
	"./t_legis.gif": "bf21",
	"./t_legis.mp4": "28b5",
	"./t_legis.webm": "0a82",
	"./t_noteup.gif": "24ec",
	"./t_noteup.mp4": "22a4",
	"./t_noteup.webm": "95ba",
	"./t_searchdemo.gif": "6e47",
	"./t_searchdemo.mp4": "b1ec",
	"./t_searchdemo.webm": "f9dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";